import React  from 'react';
import { Container } from '@mui/material';

const StepperDelete = ({ children }) => {
    return (
        <Container 
            maxWidth={false} 
            disableGutters 
            style={{ 
                maxWidth: '100%', 
                backgroundImage: `url('${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/bg-index-0.png')` 
            }}
        >
            <Container style={{ marginTop: '0px', paddingTop: 24, paddingBottom: 24 }}>
                {children}
            </Container>
        </Container>
    );
};

export default StepperDelete;
